import { Description, Divider, Title } from '../FormBuilder/components/pageElements';

export const FormHeader = ({ title, description }) => (
  <>
    {Boolean(title) && <Title />}
    {Boolean(description) && <Description />}
    {Boolean(description || title) && <Divider />}
  </>
);
